import { render, staticRenderFns } from "./WaveChart.vue?vue&type=template&id=2d087f7c"
import script from "./WaveChart.vue?vue&type=script&lang=js"
export * from "./WaveChart.vue?vue&type=script&lang=js"
import style0 from "./WaveChart.vue?vue&type=style&index=0&id=2d087f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports